import React from 'react';
import { I18n } from 'js/components/common/I18n';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';
import Body from './Body';
import style from './index.scss';

export default () => {
    const t = usePortletTranslations();
    const conversion = usePortletSelector(prop('conversion'));
    const currencyCode = useUserSelector(prop('currencyCode'));
    const { conversionRate, moneyConversionDetails, bonusConversionDetails = [] } = conversion;
    const isCashExist = Boolean(moneyConversionDetails);
    const bonusTypesTKeys = bonusConversionDetails.reduce((memo, current, index, arr) => {
        const separator = index === arr.length - 1 ? ' and ' : ', ';
        const memoWithSeparator = memo.length ? memo + separator : memo;

        return memoWithSeparator + t(current.bonusPlayType);
    }, isCashExist ? t('cash') : '');

    return <div>
        <h3 className={style.title}>{t('descriptionTitle')}</h3>
        <Body>
        <I18n t={t}
              tKey='description'
              replacers={[currencyCode, bonusTypesTKeys, conversionRate]}
        />
        </Body>
    </div>;
};
